import { Component, EventListener, GondelBaseComponent, hasMountedGondelComponent } from '@gondel/core';

enum Selectors {
	ImageWrapper = '.js-cms-stage__image',
	VideoWrapper = '.cms-stage__video-container'
}

enum Orientation {
	Undefined = 0,
	Portrait = 'portrait',
	Landscape = 'landscape'
}

@Component('Stage')
export class Stage extends GondelBaseComponent {
	private _imageWrapper: HTMLDivElement = {} as HTMLDivElement;
	private _videoWrapper: HTMLDivElement = {} as HTMLDivElement;
	private _audioCtrls: HTMLDivElement = {} as HTMLDivElement;
	private _video: HTMLVideoElement = {} as HTMLVideoElement;
	private _source: HTMLSourceElement = {} as HTMLSourceElement;
	private sources: any = {};
	private video_orientation: Orientation = Orientation.Undefined;

	public start() {
		this._imageWrapper = this._ctx.querySelector(Selectors.ImageWrapper) as HTMLDivElement;
		this._videoWrapper = this._ctx.querySelector(Selectors.VideoWrapper) as HTMLDivElement;
		this._initVideo();
		// window.addEventListener('scroll', () => this._onScroll());
		window.addEventListener('resize', () => this._onResize());
		
	}

	public stop() {
		// unregister event listener
		// window.removeEventListener('scroll', () => this._onScroll());
		window.removeEventListener('resize', () => this._onResize());
	}

	private _initVideo() {
		if (this._videoWrapper) {
			this._video = this._videoWrapper.querySelector('video') as HTMLVideoElement;
			if (this._video) {
				this._audioCtrls = this._ctx.querySelector('.cms-stage__video_ctrls') as HTMLDivElement;
				this._initCtrls(this._audioCtrls, this._video);
				this._source = this._video.querySelector('source') as HTMLSourceElement;
				const videoUrls = this._videoWrapper.getElementsByClassName('cms_stage_video_url');
				if (videoUrls.length > 0) {
					Array.from(videoUrls).forEach((videoUrl: Element) => {
						this.sources[videoUrl.getAttribute('data-orientation') as Orientation] = videoUrl.innerHTML;
					});
					this._updateVideoOrientation();
				}
			}
			
		} else {
			console.warn('No video wrapper found');
		}
	}

	private _initCtrls(ctrls: HTMLDivElement, video: HTMLVideoElement) {
		const onPlay = () => ctrls.classList.add('visible');
		video.addEventListener('playing', onPlay);
		const link = video.dataset['link'];
		const linkEl = ctrls.querySelector('.video-ctrl__link') as HTMLAnchorElement;
		if (link) {
			linkEl.setAttribute('href', link);
			linkEl.setAttribute('target', '_blank');
			linkEl.setAttribute('rel', 'noopener noreferrer');
		} else {
			ctrls.removeChild(linkEl);
		}
		const audioCtrls = ctrls.querySelector('.cms-stage__video_ctrls-audio') as HTMLDivElement;
		if (audioCtrls) {
			audioCtrls.querySelector('.audio-ctrl__muted')?.addEventListener('click', () => {
				audioCtrls.setAttribute('data-state', 'unmuted');
				video.muted = false;
			});
			audioCtrls.querySelector('.audio-ctrl__unmuted')?.addEventListener('click', () => {
				audioCtrls.setAttribute('data-state', 'muted');
				video.muted = true;
			});
		}
		
	}

	private _updateVideoOrientation() {
		const o = window.innerWidth > 669 ? Orientation.Landscape : Orientation.Portrait;
		if (this.video_orientation !== o) {
			this.video_orientation = o;
			const src = this.sources[this.video_orientation] || this.sources[Orientation.Landscape];
			if (this._source && this._source.getAttribute('src') !== src) {
				if (this._audioCtrls) {
					this._audioCtrls.classList.remove('visible');
				}
				this._source.setAttribute('src', src);
				this._video.load();
				this._video.play();
			}
		}
	}

	private _onResize() {
		this._updateVideoOrientation();
	}

	/**
	 * Moves the image wrapper element for an parallax effect
	 */
	private _onScroll() {
		// Parallax is not a feature on this website : )
		// const currentPosition = window.pageYOffset;
		// this._imageWrapper.style.top = `${currentPosition * 0.25}px`;
	}
}
